import React from "react";
import { Box, Typography } from "@mui/material";
import ClickableImage from "../..//layout/Interactive/Images/ClickableImage";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import StyledImageCarousel from "../StyledImageCarousel";

function SeedGarment({ garment, showAdditionalGarmentInfo=true, sx={}, sxImageCarousel={} }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        ...sx
      }}
    >
      <StyledImageCarousel srcs={garment?.images} sx={sxImageCarousel}/>
      
      <Typography variant="h4" sx={{mt: 2, mb: 0.5}}>{garment?.title}</Typography>
      {showAdditionalGarmentInfo && (
        <>
          <Typography variant="body1" sx={{mt: 0, userSelect: "text"}}>
            <b>ID:</b> {garment?.garment_id}
          </Typography>
          <Typography variant="body1" sx={{mb: 1, userSelect: "text"}}>
            <b>UUID:</b> {garment?.uuid_public_id}
          </Typography>
        </>
      )}
    </Box>
  );
}

export default SeedGarment;
